import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BlogList = () => {
  const { lang } = useParams();
  const safeLang = lang || "en";
  const { t } = useTranslation();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    let isMounted = true;

    import(`../../data/blog/${safeLang}/index.json`)
      .then((m) => {
        if (!isMounted) return;

        const items = Array.isArray(m.default) ? m.default : (m.default?.posts || []);
        const sorted = [...items].sort((a, b) => String(b.date).localeCompare(String(a.date)));

        setPosts(sorted);
      })
      .catch((err) => {
        console.error("❌ Error loading blog index:", err);
        setPosts([]);
      });

    return () => {
      isMounted = false;
    };
  }, [safeLang]);

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-3xl font-bold text-primary-light dark:text-primary-dark mb-4">
        {t("blog")}
      </h1>

      <div className="grid gap-6 grid-cols-1 md:grid-cols-2">
        {posts.map((post) => (
          <Link
            key={post.slug}
            to={`/${safeLang}/blog/${post.slug}`}
            className="border rounded-xl p-4 shadow hover:shadow-lg transition"
          >
            {post.image && (
              <img
                src={post.image}
                alt={post.title || "Blog post"}
                className="mb-4 w-full h-48 object-cover rounded"
                loading="lazy"
              />
            )}

            <div className="flex items-center gap-2 mb-1 flex-wrap">
              {post.cluster && (
                <span className="text-xs px-2 py-1 rounded-full border">
                  {post.cluster}
                </span>
              )}
              {Array.isArray(post.audience) && post.audience.length > 0 && (
                <span className="text-xs px-2 py-1 rounded-full border">
                  {post.audience.join(" / ").toUpperCase()}
                </span>
              )}
              {post.year && (
                <span className="text-xs px-2 py-1 rounded-full border">
                  {post.year}
                </span>
              )}
            </div>

            <h2 className="text-xl font-semibold">{post.title}</h2>
            {post.description && <p className="text-sm mt-2">{post.description}</p>}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogList;
